module.exports = __webpack_public_path__ + "static/quote-f23d87ce0497d9c29efdaef1f39ccd09.png";